import styled from "styled-components";

export const ApeArtStyled = styled.div`
  width: 100%;
  padding-bottom: 4rem;
`;
